module.exports = __webpack_public_path__ + "static/media/bill-blue.2430448c.svg";